<!--
 * @Author: cmchiu
 * @Date: 2023-03-21 13:23:44
 * @LastEditTime: 2023-03-21 15:25:29
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\App.vue
 * 
-->
<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',
    components: {},
}
</script>

<style>
/* #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
} */
</style>
